import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { HealthSystemSetup } from "../../../../core/model/v2/practice/HealthSystemSetup";
import { PracticeService } from "../../../../core/services/v2/practice.service";
import { SetupService } from "../../setup.service";
import { PractitionerSetupBase } from "../Shared/PractitionerSetupBase";

@Component({
  selector: "app-case-manager",
  templateUrl: "../Shared/practitionerSetup.component.html",
  styleUrls: ["../Shared/practitionerSetup.component.scss"],
})
export class CaseManagerComponent
  extends PractitionerSetupBase
  implements OnInit
{
  onSearchSuccess(): void {
    this.practitioner.role = "CaseManager";
  }

  // isSidebarOpened: boolean;

  onSaveSuccess(): void {
    this.save.emit();
  }
  @Input() selectedHealthSystem: HealthSystemSetup;

  @Input() isSidebarOpened: boolean = false;
  @Output() isSidebarOpenedChange = new EventEmitter<boolean>();
  @Input() availableHealthSystems: HealthSystemSetup[];
  @Output() save = new EventEmitter();
  @Input() availableRoles: string[];

  constructor(
    private _setupService: SetupService,
    private _practiceService: PracticeService,
    private _loaderService: WindowLoaderService,
    private _matSnackBar: MatSnackBar
  ) {
    super("CaseManager", _practiceService, _loaderService, _matSnackBar);
    this.showRoleSelector = false;
  }

  ngOnInit() {
    this._setupService.editCaseManager$.subscribe(
      (userSetup) => {
        userSetup.role = "CaseManager";
        this.npi = userSetup.practitioner.npi;
        this.setPractitionerToEdit(userSetup);
      },
      (error) => {
        console.error(error);
      }
    );
  }
}
